module.exports = __webpack_public_path__ + "static/img/zuowu.690316ab.png";